import React, { createContext, useContext, useState } from 'react';

const ItineraryFeeTypeIdContext = createContext();
const ItineraryFeeTypeIdSelectionContext = createContext();

export const ItineraryFeeTypeProvider = ({ children }) => {
  const [itineraryFeeTypeId, selectItineraryFeeTypeId] = useState(null);
  return (
    <ItineraryFeeTypeIdContext.Provider value={itineraryFeeTypeId}>
      <ItineraryFeeTypeIdSelectionContext.Provider
        value={selectItineraryFeeTypeId}
      >
        {children}
      </ItineraryFeeTypeIdSelectionContext.Provider>
    </ItineraryFeeTypeIdContext.Provider>
  );
};

export const useItineraryFeeTypeId = () =>
  useContext(ItineraryFeeTypeIdContext);
export const useItineraryFeeTypeIdSelection = () =>
  useContext(ItineraryFeeTypeIdSelectionContext);
